require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-polyfill/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 254
// module chunks = 0